import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { toChoiceQuestionAnswerOrEmpty } from '../../stores/QuestionStore';
import { Dropdown } from './Dropdown';
import { DropdownMultiselect } from './DropdownMultiselect';
import { EditDropdownOption } from './edit/cmdb-edit-dropdown-option';
export var CmdbDropdown = function CmdbDropdown(questionProps) {
  var _questionStore$issueF;
  var questionStore = questionProps.questionStore;
  var shouldRenderMultiple = ((_questionStore$issueF = questionStore.issueFieldData) === null || _questionStore$issueF === void 0 ? void 0 : _questionStore$issueF.multiple) !== false;
  var hasMultipleAnswers = toChoiceQuestionAnswerOrEmpty(questionStore.answer).choices.length > 1;
  if (shouldRenderMultiple || hasMultipleAnswers) {
    var customComponentsMultiselect = {
      Option: function Option(props) {
        var _questionStore$issueF2, _questionStore$issueF3;
        return /*#__PURE__*/React.createElement(EditDropdownOption, _extends({}, props, {
          filterAttributes: (_questionStore$issueF2 = (_questionStore$issueF3 = questionStore.issueFieldData) === null || _questionStore$issueF3 === void 0 ? void 0 : _questionStore$issueF3.attributes) !== null && _questionStore$issueF2 !== void 0 ? _questionStore$issueF2 : []
        }));
      }
    };
    return /*#__PURE__*/React.createElement(DropdownMultiselect, _extends({}, questionProps, {
      customComponents: fg('proforma_asset_fields_show_selected_attributes') ? customComponentsMultiselect : undefined
    }));
  } else {
    var customComponents = {
      Option: function Option(props) {
        var _questionStore$issueF4, _questionStore$issueF5;
        return /*#__PURE__*/React.createElement(EditDropdownOption, _extends({}, props, {
          filterAttributes: (_questionStore$issueF4 = (_questionStore$issueF5 = questionStore.issueFieldData) === null || _questionStore$issueF5 === void 0 ? void 0 : _questionStore$issueF5.attributes) !== null && _questionStore$issueF4 !== void 0 ? _questionStore$issueF4 : []
        }));
      }
    };
    return /*#__PURE__*/React.createElement(Dropdown, _extends({}, questionProps, {
      customComponents: fg('proforma_asset_fields_show_selected_attributes') ? customComponents : undefined
    }));
  }
};